import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

// Mentions Légales
export const MentionsLegalesPage = () => {
  return (
    <div className="overflow-hidden" data-testid="mentions-legales-page">
      <section className="py-16 bg-teal-700">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <motion.div initial="initial" animate="animate" variants={fadeInUp}>
            <Link to="/" className="inline-flex items-center text-teal-100 hover:text-white mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Link>
            <h1 className="text-4xl font-bold text-white">Mentions Légales</h1>
          </motion.div>
        </div>
      </section>
      
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 prose prose-slate max-w-none">
          <h2>Éditeur du site</h2>
          <p>
            <strong>SARL GROUPE AERH POLYNESIE</strong><br />
            10 Rue Georges Lagarde<br />
            Papeete, Polynésie française<br />
            Téléphone : +689 87 73 78 15<br />
            Email : contact@groupeaerhpolynesie.com
          </p>
          
          <h3>Directeur de la publication</h3>
          <p>Eric ASPINAS, Gérant</p>
          
          <h2>Hébergement</h2>
          <p>
            Ce site est hébergé par Emergent SAS.<br />
            Adresse : France
          </p>
          
          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
            et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
            les documents téléchargeables et les représentations iconographiques et photographiques.
          </p>
          
          <h2>Liens hypertextes</h2>
          <p>
            Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres 
            ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de 
            SARL GROUPE AERH POLYNESIE.
          </p>
          
          <h2>Protection des données personnelles</h2>
          <p>
            Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement 
            Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, 
            de suppression et d'opposition aux données personnelles vous concernant. Pour exercer ce droit, 
            adressez-vous à : contact@groupeaerhpolynesie.com
          </p>
        </div>
      </section>
    </div>
  );
};

// CGV
export const CGVPage = () => {
  return (
    <div className="overflow-hidden" data-testid="cgv-page">
      <section className="py-16 bg-teal-700">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <motion.div initial="initial" animate="animate" variants={fadeInUp}>
            <Link to="/" className="inline-flex items-center text-teal-100 hover:text-white mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Link>
            <h1 className="text-4xl font-bold text-white">Conditions Générales de Vente</h1>
          </motion.div>
        </div>
      </section>
      
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 prose prose-slate max-w-none">
          <h2>Article 1 - Objet</h2>
          <p>
            Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre 
            SARL GROUPE AERH POLYNESIE et ses clients pour les services de formation, consulting, 
            recrutement et location de salles.
          </p>
          
          <h2>Article 2 - Services proposés</h2>
          <h3>2.1 Formations</h3>
          <p>
            AERH Formations Tahiti propose des formations professionnelles en présentiel et e-learning 
            dans les domaines de la bureautique, comptabilité, paie, RH, management et communication.
          </p>
          
          <h3>2.2 Consulting</h3>
          <p>
            AERH Consulting Tahiti propose des services de conseil en création d'entreprise, 
            gestion RH, rédaction de business plan et audit.
          </p>
          
          <h3>2.3 Location de salles</h3>
          <p>
            AERH met à disposition des salles de réunion et de formation équipées au cœur de Papeete.
          </p>
          
          <h2>Article 3 - Tarifs</h2>
          <p>
            Les tarifs sont exprimés en Francs CFP (XPF). Ils sont susceptibles d'être modifiés à tout moment. 
            Les tarifs applicables sont ceux en vigueur au moment de la commande.
          </p>
          
          <h2>Article 4 - Inscription et réservation</h2>
          <p>
            Toute inscription ou réservation doit être confirmée par écrit (email ou formulaire en ligne). 
            Elle ne sera définitive qu'après réception du règlement ou de l'accord de prise en charge 
            par l'organisme financeur.
          </p>
          
          <h2>Article 5 - Conditions de paiement</h2>
          <p>
            Le règlement peut être effectué par virement bancaire, chèque ou espèces. 
            Le paiement doit être effectué avant le début de la prestation, sauf accord préalable.
          </p>
          
          <h2>Article 6 - Annulation et report</h2>
          <p>
            Toute annulation doit être notifiée par écrit. En cas d'annulation moins de 7 jours ouvrés 
            avant le début de la prestation, 50% du montant sera facturé. En cas d'annulation moins de 
            48h avant, la totalité sera due.
          </p>
          
          <h2>Article 7 - Responsabilité</h2>
          <p>
            SARL GROUPE AERH POLYNESIE ne saurait être tenue responsable des dommages indirects 
            pouvant survenir du fait de l'utilisation de ses services.
          </p>
          
          <h2>Article 8 - Droit applicable</h2>
          <p>
            Les présentes CGV sont soumises au droit applicable en Polynésie française. 
            Tout litige sera porté devant les tribunaux compétents de Papeete.
          </p>
          
          <p className="text-sm text-slate-500 mt-8">
            Dernière mise à jour : Janvier 2025
          </p>
        </div>
      </section>
    </div>
  );
};

// CGU
export const CGUPage = () => {
  return (
    <div className="overflow-hidden" data-testid="cgu-page">
      <section className="py-16 bg-teal-700">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <motion.div initial="initial" animate="animate" variants={fadeInUp}>
            <Link to="/" className="inline-flex items-center text-teal-100 hover:text-white mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Link>
            <h1 className="text-4xl font-bold text-white">Conditions Générales d'Utilisation</h1>
          </motion.div>
        </div>
      </section>
      
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 prose prose-slate max-w-none">
          <h2>Article 1 - Objet</h2>
          <p>
            Les présentes Conditions Générales d'Utilisation (CGU) définissent les modalités et conditions 
            d'utilisation du site internet du Groupe AERH Polynésie.
          </p>
          
          <h2>Article 2 - Accès au site</h2>
          <p>
            L'accès au site est gratuit. Tous les coûts liés à l'accès au site (équipement informatique, 
            connexion internet) sont à la charge de l'utilisateur.
          </p>
          
          <h2>Article 3 - Propriété intellectuelle</h2>
          <p>
            Tous les éléments du site (textes, images, logos, graphismes) sont protégés par le droit 
            de la propriété intellectuelle. Toute reproduction, même partielle, est interdite sans 
            autorisation préalable.
          </p>
          
          <h2>Article 4 - Données personnelles</h2>
          <p>
            Les informations recueillies via les formulaires du site sont destinées au Groupe AERH 
            Polynésie pour le traitement de vos demandes. Conformément au RGPD, vous disposez d'un 
            droit d'accès, de rectification et de suppression de vos données.
          </p>
          
          <h2>Article 5 - Cookies</h2>
          <p>
            Le site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des 
            statistiques de visite. L'utilisateur peut configurer son navigateur pour refuser les cookies.
          </p>
          
          <h2>Article 6 - Responsabilité</h2>
          <p>
            Le Groupe AERH Polynésie s'efforce d'assurer l'exactitude des informations publiées sur 
            le site mais ne peut garantir l'absence d'erreurs. L'utilisation des informations se fait 
            sous la responsabilité de l'utilisateur.
          </p>
          
          <h2>Article 7 - Modification des CGU</h2>
          <p>
            Le Groupe AERH Polynésie se réserve le droit de modifier les présentes CGU à tout moment. 
            Les modifications prennent effet dès leur publication sur le site.
          </p>
          
          <p className="text-sm text-slate-500 mt-8">
            Dernière mise à jour : Janvier 2025
          </p>
        </div>
      </section>
    </div>
  );
};

// Politique de Confidentialité
export const ConfidentialitePage = () => {
  return (
    <div className="overflow-hidden" data-testid="confidentialite-page">
      <section className="py-16 bg-teal-700">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <motion.div initial="initial" animate="animate" variants={fadeInUp}>
            <Link to="/" className="inline-flex items-center text-teal-100 hover:text-white mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Link>
            <h1 className="text-4xl font-bold text-white">Politique de Confidentialité</h1>
          </motion.div>
        </div>
      </section>
      
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 prose prose-slate max-w-none">
          <h2>Introduction</h2>
          <p>
            <strong>SARL GROUPE AERH POLYNESIE</strong> s'engage à protéger la vie privée de ses utilisateurs 
            et à traiter leurs données personnelles avec la plus grande confidentialité.
          </p>
          
          <h2>Responsable du traitement</h2>
          <p>
            SARL GROUPE AERH POLYNESIE<br />
            10 Rue Georges Lagarde, Papeete<br />
            Polynésie française<br />
            Email : contact@groupeaerhpolynesie.com
          </p>
          
          <h2>Données collectées</h2>
          <p>Nous collectons les données suivantes :</p>
          <ul>
            <li>Données d'identification : nom, prénom, email, téléphone</li>
            <li>Données professionnelles : entreprise, fonction</li>
            <li>Données de connexion : adresse IP, cookies</li>
            <li>Données de formation : parcours, résultats (pour les apprenants)</li>
          </ul>
          
          <h2>Finalités du traitement</h2>
          <p>Les données sont collectées pour :</p>
          <ul>
            <li>Répondre à vos demandes de contact</li>
            <li>Gérer les inscriptions aux formations</li>
            <li>Traiter les réservations de salles</li>
            <li>Envoyer des informations sur nos services (avec votre consentement)</li>
            <li>Améliorer nos services et notre site</li>
          </ul>
          
          <h2>Base légale</h2>
          <p>
            Le traitement de vos données est basé sur votre consentement, l'exécution d'un contrat 
            ou nos intérêts légitimes à améliorer nos services.
          </p>
          
          <h2>Durée de conservation</h2>
          <p>
            Les données sont conservées pendant la durée nécessaire aux finalités pour lesquelles 
            elles ont été collectées, et au maximum 3 ans après le dernier contact.
          </p>
          
          <h2>Vos droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité</li>
            <li>Droit d'opposition</li>
          </ul>
          
          <h2>Exercer vos droits</h2>
          <p>
            Pour exercer vos droits, contactez-nous à : contact@groupeaerhpolynesie.com<br />
            Vous disposez également du droit d'introduire une réclamation auprès de la CNIL.
          </p>
          
          <h2>Sécurité</h2>
          <p>
            Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour 
            protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
          </p>
          
          <p className="text-sm text-slate-500 mt-8">
            Dernière mise à jour : Janvier 2025
          </p>
        </div>
      </section>
    </div>
  );
};

export default { MentionsLegalesPage, CGVPage, CGUPage, ConfidentialitePage };
